export const traceabilityTr = {
  title: 'Parti soyağacı ve izlenebilirlik',
  subtitle:
    'Tüketilen ve üretilen partileri tüm üretim seviyelerinde izleyin ve geri çağırma etkilerini değerlendirin.',
  help: { open: 'Parti soyağacı ve geri çağırma simülasyonları yardımını aç' },
  tabs: { trace: 'Partileri izle', simulations: 'Geri çağırma simülasyonları' },
  filters: {
    title: 'İzlenebilirlik filtreleri',
    description:
      'En az bir parti, ürün, iş ortağı veya üretim emri seçin. Tüm filtreler kiracıya göre yalıtılmıştır.',
    batch: 'Parti',
    batchNumber: 'Parti numarası şunu içerir',
    product: 'Ürün',
    supplier: 'Tedarikçi',
    customer: 'Müşteri',
    productionOrder: 'Üretim emri',
    from: 'Kabul başlangıcı',
    to: 'Kabul bitişi',
    direction: 'Yön',
    depth: 'Azami seviye',
    any: 'Tümü',
  },
  directions: {
    FORWARD: 'Nihai ürünlere doğru',
    BACKWARD: 'Hammaddelere doğru',
    BOTH: 'Her iki yön',
  },
  relations: {
    ANCHOR: 'Başlangıç partisi',
    UPSTREAM: 'Önceki malzeme',
    DOWNSTREAM: 'Sonraki ürün',
    BOTH: 'İki yönde bağlı',
  },
  batchStatuses: {
    FREE: 'Serbest',
    QUARANTINE: 'Karantina',
    BLOCKED: 'Bloke',
    EXPIRED: 'Süresi dolmuş',
    DEPLETED: 'Tükenmiş',
  },
  actions: {
    calculate: 'İzlemeyi çalıştır',
    reset: 'Filtreleri sıfırla',
    createSimulation: 'Geri çağırma simülasyonu oluştur',
    review: 'İncele',
    cancel: 'İptal et',
    confirmBlocks: 'Etkilenen partileri bloke et',
    export: 'CSV dışa aktar',
  },
  messages: {
    invalidFilter: 'İzlenebilirlik filtreleri eksik.',
    simulationCreated: 'Değiştirilemez anlık görüntüden simülasyon oluşturuldu.',
    review: 'Geri çağırma simülasyonu incelendi.',
    cancel: 'Geri çağırma simülasyonu iptal edildi.',
    blocksConfirmed: 'Stokta bulunan etkilenen partiler bloke edildi.',
  },
  warnings: {
    truncatedTitle: 'Sonuç sınırına ulaşıldı',
    truncated:
      'Grafik seçilen derinlikte veya güvenlik sınırında kesildi. Filtreleri daraltın ya da derinliği artırın.',
  },
  stats: {
    lots: 'Etkilenen partiler',
    productionOrders: 'Üretim emirleri',
    deliveries: 'Teslimatlar',
    customers: 'Müşteriler',
  },
  graph: {
    title: 'Çok seviyeli malzeme akışı',
    description: 'Oklar tüketilen partilerden üretilen partilere doğru malzeme akışını gösterir.',
    ariaLabel: 'Önceki ve sonraki partilerin grafiği',
    snapshotTitle: 'Dondurulmuş soyağacı anlık görüntüsü',
    snapshotDescription: 'Bu grafik simülasyon oluşturulurken kaydedilen kanıtla birebir aynıdır.',
  },
  impact: {
    title: 'Etkilenen stoklar, belgeler ve iş ortakları',
    description: 'Etki, izlenen tüm parti kümesinden türetilir.',
    inventory: 'Mevcut stok',
    documents: 'Belgeler ve teslimatlar',
    partners: 'İş ortakları',
    productionOrders: 'Üretim emirleri',
    suppliers: 'Tedarikçiler',
    customers: 'Müşteriler',
    snapshotTitle: 'Dondurulmuş etki analizi',
  },
  columns: {
    article: 'Ürün',
    batch: 'Parti',
    relation: 'İlişki',
    status: 'Durum',
    warehouse: 'Depo / konum',
    available: 'Kullanılabilir',
    document: 'Belge',
    type: 'Tür',
    customer: 'Müşteri',
    date: 'Tarih',
    batches: 'Partiler',
    productionOrder: 'Üretim emri',
    product: 'Ürün',
    completed: 'Tamamlandı',
  },
  empty: {
    inventory: 'Etkilenen mevcut stok yok.',
    documents: 'Etkilenen belge yok.',
    partners: 'Etkilenen iş ortağı yok.',
    orders: 'Etkilenen üretim emri yok.',
    trace: 'Parti soyağacını görüntülemek için filtre seçin.',
    simulations: 'Geri çağırma simülasyonu bulunamadı.',
    selectSimulation: 'Bir geri çağırma simülasyonu seçin.',
  },
  simulations: {
    search: 'Numara, başlık veya neden ara',
    allStatuses: 'Tüm durumlar',
    title: 'Kaydedilen simülasyonlar',
    description: 'Her kayıt grafiğini, etkisini, filtrelerini ve SHA-256 kanıtını korur.',
    noNotificationTitle: 'Harici bildirim yok',
    noNotification:
      'Bu iş akışı müşterilere, tedarikçilere veya makamlara bildirim göndermez. Harici iletişim ayrı, açık ve yetkili bir işlem gerektirir.',
  },
  statuses: {
    DRAFT: 'Taslak',
    REVIEWED: 'İncelendi',
    BLOCKS_CONFIRMED: 'Partiler bloke edildi',
    CANCELLED: 'İptal edildi',
  },
  fields: {
    title: 'Başlık',
    reason: 'Neden',
    note: 'Karar notu',
    createdAt: 'Oluşturulma',
    direction: 'İzleme yönü',
    snapshotHash: 'Anlık görüntü SHA-256',
    blockedBatches: 'Bloke partiler',
  },
  create: {
    title: 'Geri çağırma simülasyonu oluştur',
    description:
      'Mevcut grafik ve etki değiştirilemez bir anlık görüntü olarak dondurulur. Henüz hiçbir parti bloke edilmez.',
  },
  workflow: {
    review: {
      title: 'Geri çağırma simülasyonunu incele',
      description: 'Dondurulmuş etkinin mevcut kanıtlarla kontrol edildiğini doğrulayın.',
    },
    cancel: {
      title: 'Geri çağırma simülasyonunu iptal et',
      description: 'Anlık görüntü denetim için korunur; etkilenen partiler değiştirilmez.',
    },
  },
  block: {
    title: 'Etkilenen partileri açıkça bloke et',
    description:
      'Stokta bulunan {{count}} etkilenen parti işlem içinde değerlendirilecek ve bloke edilecektir.',
    notificationTitle: 'Harici iletişim kapsam dışıdır',
    notificationDescription: 'Stok blokesi e-posta, mesaj veya mevzuat bildirimi göndermez.',
    confirmLots: 'Stokta bulunan tüm etkilenen partilerin bloke edilmesini açıkça onaylıyorum.',
    confirmNoNotification: 'Bu işlemin hiçbir harici bildirim göndermediğini anlıyorum.',
  },
} as const;
